export const POST_TYPES = {
  LOST: 'LOST',
  PROTECTED: 'PROTECTED',
  WITNESS: 'WITNESS',
};

export const SPECIES = {
  DOG: 'DOG',
  CAT: 'CAT',
};

export const PET_GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  UNKNOWN: 'UNKNOWN',
};

export const KAKAO_APP_KEY = process.env.REACT_APP_KAKAO_APP_KEY || '';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
